<template>
  <page>
    <template slot="content">
      <help-content :title="'一部の歩数が記録されない(Android)'">
        <template slot="content">
          <div class="text">画面ロック中でも歩数を計測するように、左スライドメニュー＞<b>画面ロック中計測</b>をオンにしてください。</div>
          <div class="text">また、一部の歩数データが記録されない場合、バックグラウンド実行中のプロセスが強制終了させられている可能性があります。<br>
          左スライドメニュー＞<b>電池の最適化しない</b>をタップし、<b>すでに電池最適化の対象外です</b>のメッセージが表示されたら再度お試しください。</div>
          <img class="picture" src="../assets/images/q_and_a/H4_1.png">
        </template>
      </help-content>
    </template>
  </page>
</template>

<script>
  import HelpContent from '@/components/HelpContent'
  import Page from '@/components/Page'

  export default {
    components: {
      HelpContent,
      Page
    },
    mounted () {
      window.scrollTo(0, 0)
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Help4.vue